import React from 'react';
import { Link } from 'react-router-dom';

export function NotFound() {
    return (
        <div className="container" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="text-center" style={{ maxWidth: '600px' }}>
                <h1 style={{ fontSize: '120px', fontWeight: 'bold', marginBottom: '20px', color: '#d9534f' }}>
                    404
                </h1>
                <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#333' }}>
                    Página No Encontrada
                </h2>
                <p style={{ fontSize: '16px', marginBottom: '30px', color: '#666' }}>
                    Lo sentimos, la página que estás buscando no existe o ha sido movida.
                    Por favor, regresa a la página principal.
                </p>
                <Link
                    to="/"
                    className="btn"
                    style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        padding: '12px 30px',
                        borderRadius: '5px',
                        textDecoration: 'none',
                        display: 'inline-block',
                        marginRight: '15px'
                    }}
                >
                    Ir a Inicio
                </Link>
                <Link
                    to="/browse-job-filter-grid"
                    className="btn"
                    style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        padding: '12px 30px',
                        borderRadius: '5px',
                        textDecoration: 'none',
                        display: 'inline-block'
                    }}
                >
                    Buscar Vacantes
                </Link>
            </div>
        </div>
    );
}
